
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.md?watch=parent';
    export const demoIndex = {
  ids: ["radar-demo-common","radar-demo-markdown","radar-demo-category"],
  getter: () => import(/* webpackChunkName: "meta__Radar" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.md?type=demo')
};